var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isLoading
      ? _c("div", [
          _c(
            "div",
            { staticClass: "pt-3 pb-5" },
            [
              _c("news-feed-loading-skeleton", {
                attrs: { count: _vm.loadingSkeletonCount }
              })
            ],
            1
          )
        ])
      : _c("div", [
          _c("div", { staticClass: "row pt-4" }, [
            _c("div", { staticClass: "col-12 col-xl-9" }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.title) } })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-xl-3 pt-2 pt-xl-1 d-flex justify-content-xl-end"
              },
              [
                _vm.enableEditInterests
                  ? _c(
                      "div",
                      [
                        _c("edit-interests-button", {
                          attrs: { topics: _vm.topics }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _vm.isErrored
            ? _c("div", { staticClass: "alert alert-error" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                    "\n    "
                )
              ])
            : _c("div", [
                _vm.posts && _vm.posts.length > 0
                  ? _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _vm._l(_vm.posts, function(post) {
                          return _c("div", { key: post.id }, [
                            _c(
                              "div",
                              { staticClass: "pb-3" },
                              [
                                _c("news-feed-card", {
                                  attrs: {
                                    "post-data": post,
                                    "show-interest-tag": _vm.enableEditInterests
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _vm.enableLoadMore
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "load-more-wrapper d-flex justify-content-center pb-4"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center pb-4"
                                  },
                                  [
                                    _vm.isMoreLoading
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "more-loading-spinner"
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/iris_spinner.gif"),
                                                alt: "Loading Spinner"
                                              }
                                            })
                                          ]
                                        )
                                      : _vm.showLoadMore
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "homebase-btn-secondary",
                                            on: { click: _vm.onLoadMoreClicked }
                                          },
                                          [
                                            _vm._v(
                                              "\n              Load more\n            "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  : _c("div", { staticClass: "mt-4" }, [
                      _vm._v("No news to display")
                    ])
              ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c451140", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c451140","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/newsByInterests/NewsFeed.vue
// module id = null
// module chunks = 